import { render, staticRenderFns } from "./duoDynamicForm.vue?vue&type=template&id=494fe092&scoped=true&"
import script from "./duoDynamicForm.vue?vue&type=script&lang=js&"
export * from "./duoDynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./duoDynamicForm.vue?vue&type=style&index=0&id=494fe092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fe092",
  null
  
)

export default component.exports